import { render, staticRenderFns } from "./validation.vue?vue&type=template&id=5731994e&scoped=true&"
import script from "./validation.vue?vue&type=script&lang=js&"
export * from "./validation.vue?vue&type=script&lang=js&"
import style0 from "./validation.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./validation.vue?vue&type=style&index=1&id=5731994e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5731994e",
  null
  
)

export default component.exports